import RequestApi from "../../utils/request";

export default {
	GetTopElement:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/FrontEnd/Api/Universal/GetTopElement/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
	GetBottomElement:(Data) => {
		// console.log(Data);
		var Url = '/M.C.Leung/FrontEnd/Api/Universal/GetBottomElement/';
		var Method = 'post';
		var Type = '';
		return RequestApi(Url, Method, Data, Type);
	},
}

